(function () {
    "use strict";

    angular.module("app").component("habilFvmIdentityView", {
        templateUrl: '@/fvm/identity/FvmIdentityView.html',
        bindings: {
            fvmIdentity: "<",
            onChangeLanguage: "&",
            editMode: "@"
        },
        controller: IdentityViewController
    });


    IdentityViewController.$inject = ["$rootScope", "$scope", "translationsService", "codesService", "HabilNavigator"];
    function IdentityViewController($rootScope, $scope, translationsService, codesService, HabilNavigator) {
        const $controller = this;

        //#region Lifecycle

        $controller.$onInit = initialize;

        //#endregion

        //#region Methods

        $controller.OpenKBOPublicSearch = openKBOSearch;

        //#endregion

        //#region Implementation

        function initialize() {
            translationsService.loadTranslations(t => $scope.translations = t);
            codesService.loadAllCodes(() => {
                $scope.codeNationalities = $rootScope.codeNationalities;
                $scope.codeLegalForms = $rootScope.codeLegalForms;
                $scope.codeCountries = $rootScope.codeCountries;
                $scope.codeLanguages = $rootScope.codeLanguages;
            });
        }

        function openKBOSearch() {
            if (!$controller.fvmIdentity)
                return;
            HabilNavigator.OpenKboSearchNumberInTab($controller.fvmIdentity.KBONbr);
        }

        //#endregion
    }
})();